class IntroHint {
    id: string;
    hint: string;
    message: string;
    element: string;
    visible: KnockoutObservable<boolean> = ko.observable(true);
    private elementRef: Element | null = null;
    shiftX: number;
    shiftY: number;
    introId: string;
    private _intro: Intro;
    private _observer: IntersectionObserver;

    get intro() {
        if (!this._intro && this.introId) {
            this._intro = IntroService.intros.find(intro => intro.id === this.introId);
        }
        return this._intro;
    }

    left: KnockoutObservable<string> = ko.observable("0px");
    top: KnockoutObservable<string> = ko.observable("0px");
    
    updatePosition () {
        if (this.elementRef) {
            let rect = this.elementRef.getBoundingClientRect();
            this.left(`${rect.left + window.scrollX + this.shiftX}px`);
            this.top(`${rect.top + window.scrollY + this.shiftY}px`);
        }
    }

    constructor(id: string, element: string, hint: string, message: string, introId: string = null, shiftX: number = 0, shiftY: number = 0) {
        this.id = id;
        this.hint = hint;
        this.message = message;
        this.element = element;
        this.elementRef = document.querySelector(this.element);
        this.introId = introId;
        this.shiftX = shiftX;
        this.shiftY = shiftY;
        this.setVisible();
        this.createObserver();
    }

    createObserver() {
        let self = this;
        if (self.elementRef != null) {
            this._observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        self.visible(true);
                        self.updatePosition();
                    } else {
                        self.visible(false);
                    }
                });
                }, {
                    threshold: 0.1 // visible percentage of the element (in this case 10%)
                }
            );
            this._observer.observe(self.elementRef!);
        }
    }

    dispose() {
        this._observer?.disconnect();
    }

    setVisible(forceVisible: boolean = false) {
        this.visible(this.elementRef != null && (forceVisible || localStorage.getItem(`intro-hint-${this.id}`) !== "true"));
        this.updatePosition();
    }

    save() {
        localStorage.setItem(`intro-hint-${this.id}`, "true");
    }

    refresh() {
        if (this.elementRef === null) {
            this.elementRef = document.querySelector(this.element);
            this.setVisible();
            this.createObserver();
        }
         else {
            let elementRef = document.querySelector(this.element);
            if (elementRef !== this.elementRef) {
                this.dispose();
                
                this.elementRef = elementRef;
                this.setVisible();
                this.createObserver();
            }
            else {
                this.updatePosition();
            }
        }
    }
}